<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Cadastro de Feriado
        </h1>
      </b-col>
    </div>
    <b-card>
      <b-form>
        <b-alert variant="danger" :show="msgErroFormulario">
          {{ msgErroFormulario }}
        </b-alert>
        <b-row>
          <b-col md="10">
            <b-form-group id="groupDescricao" label="Descrição:" label-for="descricao">
              <b-form-input
                maxlength="100"
                id="descricao"
                name="descricao"
                v-model="filtro.descricao"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group label="Data do Feriado:" label-for="dataFeriado">
              <b-form-input type="date" v-model="filtro.dataFeriado"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
            <b-form-group
              label="Situação:"
              label-for="situacao"
              class="text-label"
            >
              <b-form-radio-group
                id="radio-group-1"
                v-model="filtro.situacao"
                :options="situacao.options"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between">
            <div>
              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                @click="filtrar"
              >
                <i class="fa fa-search"></i> Pesquisar
              </b-button>
              <b-button
                variant="primary"
                @click.prevent="openIncluir"
                class="fonte-branca ml-1"
              >
                <i class="fa fa-plus"></i> Incluir
              </b-button>

              <b-button
                variant="primary"
                class="fonte-branca ml-1"
                @click.prevent="openAlterar"
                :disabled="selecionados.length !== 1"
              >
                <i class="fa fa-pencil"></i> Alterar
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-modal
        @show="resetModal"
        size="lg"
        ref="modalFeriado"
        id="modal-center"
        scrollable
        centered
        header-bg-variant="primary"
        header-text-variant="white"
        :title="titleModal"
        footer-class="d-flex justify-content-center align-items-center"
        :sortable="true"
      >
        <label class="float-right">(*) campo obrigatório</label>
        <b-form>
          <b-alert variant="danger" :show="msgErroFormulario">
            {{ msgErroFormulario }}
          </b-alert>
          <b-form-group id="groupDescricao" label="Descrição: *" label-for="descricao">
            <b-form-input
              maxlength="80"
              id="descricao"
              name="descricao"
              v-validate="{ required: true, max: 100 }"
              v-model="feriado.descricao"
              type="text"
              required
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Data: *" label-for="dataFeriado">
            <b-form-input type="date" v-model="feriado.dataFeriado" required></b-form-input>
          </b-form-group>

          <template v-if="indAlterar">
            <b-form-group
              label="Situação: *"
              label-for="radio-group-edit-situacao"
            >
              <b-form-radio-group
                id="radio-group-edit-situacao"
                v-model="feriado.indAtivo"
                name="radio-situacao"
              >
                <b-form-radio value="1" :checked="true">Ativo</b-form-radio>
                <b-form-radio value="0">Inativo</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </template>
        </b-form>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="salvar"
            :disabled="inSave"
          >
            <i class="fa fa-save"></i> Salvar
          </b-button>
          <b-button
            class="fonte-branca ml-1"
            variant="primary"
            @click.prevent="cancel()"
          >
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </template>
      </b-modal>

      <b-row class="mt-3">
        <b-col xs="12" md="12" class="mx-auto">
          <b-col xs="12">
            <div>
              <b-row class="d-flex justify-content-between">
                <b-col>
                  <label class="mt-3">
                    Feriados - Quantidade: <strong>{{ items.length }}</strong>
                  </label>
                </b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
              <b-table
                :no-border-collapse="false"
                striped hover bordered responsive small
                :perPage="configTable.perPage"
                :currentPage="configTable.currentPage"
                :items="items"
                :busy="configTable.load"
                :fields="fieldsFeriados"
                :sort-by="configTable.sortField"
                :sort-desc="true"
                :sort-compare="sortCompare"
                class="mb-0"
                head-variant="light"
                show-empty
              >
              <template slot="empty">
                  <p class="my-auto">Nenhum Feriado encontrado.</p>
              </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template slot="selecao" slot-scope="row">
                  <b-form-checkbox
                    v-model="row.item.selecao"
                    name="checkbox-1"
                    :unchecked-value="false"
                    :value="true"
                    @input="selecionar(row.item)"
                    :disabled="row.item.erro"
                  >
                  </b-form-checkbox>
                </template>

                <template slot="data" slot-scope="row">
                  <div>
                    {{ formatarData(row.item.data) }}
                  </div>
                </template>

                <template slot="descricao" slot-scope="row">
                  <div>
                    {{ row.item.descricao }}
                  </div>
                </template>

                <template slot="indAtivo" slot-scope="row">
                  <div>
                    {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }}
                  </div>
                </template>
              </b-table>
              <b-row class="d-flex justify-content-between">
                <b-col style="background: #F0F3F5;" class="mx-3">
                  <div style="float: right;">
                    Total linhas: {{ getTotalInPage() }}
                  </div>
                </b-col>
              </b-row>
              <b-row class="d-flex justify-content-between mt-3">
                <b-col></b-col>
                <b-col>
                  <CompPaginacao :configTable="configTable" />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import axios from "axios";
import CompPaginacao from "../components/CompPaginacao";
import formatarMixins from '../../../mixins/formatarMixins'

const urlApi = process.env.VUE_APP_ROOT_API;
export default {
  name: "TabelaFeriado",
  mixins: [ formatarMixins ],
  components: {
    CompPaginacao,
  },
  data() {
    return {
      situacao: {
        selected: "todos",
        options: [
          { text: "Todos", value: "todos" },
          { text: "Ativo", value: "ativo" },
          { text: "Inativo", value: "inativo" },
        ],
      },
      items: [],
      fieldsFeriados: [
        {
          key: "selecao",
          sortable: false,
          label: "Sel.",
          thStyle: {
            width: "40px"
          }
        },
        {
          key: "data", 
          sortable: true,
          label: "Data",
          thStyle: {
            width: "200px"
          }
        },
        {
          key: "descricao",
          sortable: true,
          label: "Descrição",
        },
        {
          key: "indAtivo",
          sortable: true,
          label: "Situação",
          thStyle: {
            width: "200px"
          }
        },
      ],
      selecionados: [],
      configTable: {
        perPage: 100,
        sortField: "data",
        currentPage: 1,
        rows: 0,
        checkedAll: false,
        load: false,
      },
      filtro: {
        descricao: null,
        data: null,
        situacao: 'todos',
      },
      feriado: {
        id: null,
        descricao: null,
        dataFeriado: null,
        indAtivo: true,
      },
      indAlterar: false,
      inSave: false,
      msgErroFormulario: null,
      titleModal: "Incluir",
    };
  },
  methods: {
    /**
     * Consultar divídas
     */
     async consultar() {
      this.loadingEnter();
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      const params = {
        ...this.filtro
      }
      if (params.dataFeriado == '')
        delete params.dataFeriado;

      axios.get(`${urlApi}/v1/feriado`, {
          params: params,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        .then((response) => {
          const data = response.data
          this.items = data
          this.configTable.rows = data.length
        })
        .catch((error) => {
          error
        })
        .finally(() => {
          this.loadingExit();
        });
    },
    selecionar(item) {
      if (item.selecao) {
        if (!this.selecionados.includes(item)) {
          this.selecionados.push(item);
        }
      } else {
        const index = this.selecionados.indexOf(item);
        if (index > -1) { 
          this.selecionados.splice(index, 1);
        }
      }
    },
    /**
     * Filtrar a consulta
     */
     filtrar() {
      this.configTable.currentPage = 1;
      this.configTable.rows = 0;
      this.configTable.checkedAll = false;
      this.resultado = [];
      this.selecionados = [];
      this.consultar();
    },

    resetModal() {
      (this.feriado = {
        id: null,
        descricao: null,
        dataFeriado: null,
        indAtivo: true,
      }),
        (this.msgErroFormulario = null);
    },
    /**
     * Salvar
     */
    async salvar(evt) {
      evt.preventDefault();
      this.inSave = true;
      this.msgErroFormulario = null;
      this.feriado.dataFeriado = this.feriado.dataFeriado || null

      this.$validator.validateAll().then(async (result) => {
        if (!result || !this.feriado.dataFeriado) {
          this.msgErroFormulario = "Favor preencher os campos obrigatórios (*)";
          this.inSave = false;
          return;
        }

        const feriadoSave = {
          id: this.feriado.id,
          descricao: this.feriado.descricao,
          data: this.feriado.dataFeriado,
          indAtivo: this.feriado.indAtivo == 0 ? false : true,
        };

        if (this.indAlterar) {
          await this.alterar(feriadoSave)
        } else {
          await this.incluir(feriadoSave)
        }
      });
      this.inSave = false;
    },
    async incluir(feriadoSave) {
      const token = JSON.parse(this.$store.getters.getUser).access_token;
      await axios
          .post(`${urlApi}/v1/feriado`, feriadoSave, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          })
          .then((response) => {
            if (response.data) {
              this.msgErroFormulario = `${response.data.message}`;
              return;
            }
            this.$store.commit("setMessages", {
              message: "Sucesso",
              variant: "success",
              errors: ["Operação realizada com sucesso!!!"],
            });
            this.$refs["modalFeriado"].hide();
            this.selecionados = [];
            this.consultar();
          })
          .catch((error) => {
            this.exibirErro(error);
          })
          .finally(() => {
            this.inSave = false;
          });
    },
    async alterar(feriadoSave) {
      const token = JSON.parse(this.$store.getters.getUser).access_token;
      await axios
          .put(`${urlApi}/v1/feriado/${feriadoSave.id}`, feriadoSave, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          })
          .then((response) => {
            if (response.data) {
              this.msgErroFormulario = `${response.data.message}`;
              return;
            }
            this.$store.commit("setMessages", {
              message: "Sucesso",
              variant: "success",
              errors: ["Operação realizada com sucesso!!!"],
            });
            this.$refs["modalFeriado"].hide();
            this.selecionados = [];
            this.consultar();
          })
          .catch((error) => {
            this.exibirErro(error);
          })
          .finally(() => {
            this.inSave = false;
          });
    },

    /**
     * Incluir
     */
    openIncluir(evt) {
      evt.preventDefault();
      this.indAlterar = false;
      this.$refs["modalFeriado"].show();
      this.titleModal = "Incluir Feriado";
    },

    /**
     * Alterar
     */
    openAlterar(evt) {
      evt.preventDefault();
      if (!this.selecionados[0]) {
        return;
      }
      this.indAlterar = true;
      this.$refs["modalFeriado"].show();
      this.titleModal = "Alterar";
      const {
        id,
        descricao,
        data,
        indAtivo,
      } = this.selecionados[0];
      this.feriado.id = id;
      this.feriado.descricao = descricao;
      this.feriado.dataFeriado = data;
      this.feriado.indAtivo = indAtivo ? 1 : 0;
    },

    /**
     * Exibe erros dos catch
     */
    exibirErro(error) {
      this.$store.commit("setMessages", { message: "Erro!", errors: [error] });
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingEnter() {
      this.configTable.load = true;
    },

    /**
     * Controle do Loading da Tabela
     */
    loadingExit() {
      this.configTable.load = false;
    },

    getTotalInPage() {
      if (this.configTable.rows < this.configTable.perPage) {
        return this.configTable.rows
      } else {
        const qtdPg = this.configTable.rows / this.configTable.perPage

        if (this.configTable.currentPage < qtdPg) return this.configTable.perPage

        return this.configTable.rows - (this.configTable.perPage * (this.configTable.currentPage - 1))
      }
    },
    sortCompare(a, b, key) {
      if (key === 'data') {
        // Assuming the date field is a `Date` object, subtraction
        // works on the date serial number (epoch value)
        return new Date(a[key]) - new Date(b[key])
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    }
  },
  watch: {
    perPage() {
      this.configTable.currentPage = 1;
      this.consultar();
    },
  },
  computed: {
    perPage() {
      return this.configTable.perPage;
    },
  },
  mounted() {
    this.$store.commit("setMessages", {});

    this.consultar();
  },
};
</script>

<style scoped></style>
